import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthContext'

type Props = {}

const Header = (props: Props) => {
    const {user, logout } = useContext<any>(AuthContext)
    const navigate = useNavigate()

    function handleLogout() {
        logout()
        navigate("/")
        return window.location.reload()
    }

    return (
		<header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center">
                    <img src="/img/logo.png" alt=""/>
                    <span className="d-none d-lg-block">Cloudatik Admin</span>
                </a>
                <i className="bi bi-list toggle-sidebar-btn" onClick={()=>{
                    document.querySelector<HTMLElement>("body")!.classList.toggle('toggle-sidebar')
                }}></i>
            </div>


            <nav className="header-nav ms-auto">
            <ul className="d-flex align-items-center">


                

                <li className="nav-item dropdown pe-3">

                <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                    <img src="/img/profile-img.jpg" alt="Profile" className="rounded-circle"/>
                    <span className="d-none d-md-block dropdown-toggle ps-2">{user.username ? user.username : ""}</span>
                </a>

                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                    <li className="dropdown-header">
                    <h6>{user.username ? user.username : handleLogout()}</h6>
                    <span style={{textTransform: "capitalize"}}>{user.role ? user.role : ""}</span>
                    </li>
                    <li>
                    <hr className="dropdown-divider"/>
                    </li>
                    <li onClick={()=>handleLogout()}>
                    <a className="dropdown-item d-flex align-items-center" href="#">
                        <i className="bi bi-box-arrow-right"></i>
                        <span>Sign Out</span>
                    </a>
                    </li>

                </ul>
                </li>

            </ul>
            </nav>

        </header>
    )
}

export default Header